module.exports = __webpack_public_path__ + "img/75666.6bc4055e.svg";